export default __webpack_public_path__ + "static/media/owl-lantern.36d5e789.webp";